export const isEmailValid = (email: string): boolean => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
};

export const isMetadataNameValid = (name: string): boolean => {
  if (name.length < 1 || name.length > 63) return false;

  const regex = /^[A-Za-z0-9_.-]+$/;
  return regex.test(name);
};

export const isLabelKeyValid = (labelKey: string): boolean => {
  return isMetadataNameValid(labelKey);
};
